import React, { useState, useEffect } from 'react';
import './pages_documentos.css';
import { getDatabase, ref, get } from 'firebase/database';
import firebaseApp, { KEY_LINK, KEY_REF } from '../adm/admin/firebaseConfig';
import { Box } from '@mui/material';
import TitleSection from '../utils/TittleTheme';
import DataTable from '../utils/Tabela';

export default function Decretos() {
  const [newsData, setNewsData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const databaseInstance = getDatabase(firebaseApp);
        const noticiasRef = ref(databaseInstance, `decretos`);

        const snapshot = await get(noticiasRef);
        const data = snapshot.val();

        if (data) {
          const newsArray = Object.keys(data).map((key) => ({
            id: key,
            title: data[key].nome,
            numero: data[key].numero || null,
            mes: data[key].mes,
            dia: data[key].dia || null,
            ano: data[key].ano,
            href: data[key].href,
            timestamp: data[key].timestamp || null
          }));

          // ORDENAR
          newsArray.sort((a, b) => {
            const hasTimestampA = !!a.timestamp;
            const hasTimestampB = !!b.timestamp;

            // 1. Ambos têm timestamp → ordenar por timestamp desc
            if (hasTimestampA && hasTimestampB) {
              return b.timestamp - a.timestamp;
            }

            // 2. Apenas um tem timestamp → ele vem primeiro
            if (hasTimestampA && !hasTimestampB) return -1;
            if (!hasTimestampA && hasTimestampB) return 1;

            // 3. Nenhum tem timestamp → ordenar por ano
            if (a.ano !== b.ano) return b.ano - a.ano;

            // 4. Ordenar por mês (string → número)
            const meses = {
              janeiro: 1, fevereiro: 2, março: 3, abril: 4,
              maio: 5, junho: 6, julho: 7, agosto: 8,
              setembro: 9, outubro: 10, novembro: 11, dezembro: 12
            };

            const mesA = meses[a.mes?.toLowerCase()] || 0;
            const mesB = meses[b.mes?.toLowerCase()] || 0;

            if (mesA !== mesB) return mesB - mesA;

            // 5. Ordenar por dia (se existir)
            if (a.dia && b.dia) return Number(b.dia) - Number(a.dia);

            return 0;
          });

          setNewsData(newsArray);
        }
      } catch (error) {
        console.error('Erro ao carregar notícias:', error);
      }
    };

    fetchData();
  }, []);


  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <Box sx={{ padding: 3, maxWidth: '1200px', mx: 'auto' }}>


      <TitleSection title={'DECRETOS MUNICIPAIS'} subtitle={'Decretos municipais são atos que regulamentam leis, definem regras administrativas e estabelecem diretrizes locais, sem necessidade de aprovação legislativa.'} />

      <DataTable data={newsData} />
    </Box>
  );
}
